// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1DOrs","footer":"ModalUpdate_footer__2BUpD"};